export enum Status {
  Inactivo = 0,
  Activo = 1,
  Baja = 2,
  Pendiente = 3,
  Contactado = 4,
  Cerrado = 5,
  EnProceso = 6,
  Enviado = 7,
  Error = 8,
  Duplicado = 9,
  ContactoNoDisponible = 10,
  Borrador = 11,
  EnTratamiento = 12,
  Nuevo = 13,
  ContactoBajaComunicaciones = 14,
  Realizada = 15,
  ContactoDeseleccionado = 16,
  CampanaCompatible = 17,
  CampanaNoCompatible = 18,
  EnvioAprobado = 19,
  EnvioPausado = 20,
  EnvioRechazado = 21,
  NoConfigurado = 22,
  Configurado = 23,
  Warning = 24,
  Delayed = 25,
  RLeadPendienteAprobacion = 26,
  RLeadAprobado = 27,
  RLeadEnviado = 28,
  RLeadError = 29
}

export enum LogType {
  Login = 1,
  Nav = 2,
  Open = 3,
  Click = 4,
  OptOut = 5,
  Logout = 7

}


export enum LeadType {
  Pv = 1,
  Reclamacion = 2,
  Vn = 3
}

export enum LeadSubtype {
  PvSrc = 1,
  RechazoGrua = 2,
  Salesforce = 3,
  Reclamacion = 4
}

export enum LeadPermission {
  CreateLead = 1,
  CreateMessage = 2,
  View = 3
}

export enum LocalCampaignMedia {
  Email = 1,
  Sms = 2,
  Telemarketing = 3
}

export enum LocalCampaignCompType {
  Compatible = 1,
  NoCompatible = 2,
  Libre = 3
}

export enum RenaulLeadBrand {
  Renault = 1,
  Dacia = 2,
  Alpine = 3,
  Mobilize = 4,
  Otra = 5
}


export enum Kpis {
  BonusPo_Realizacion = 1,
  BonusPo_Objetivo = 2,
  BonusPoe_Realizacion = 3,
  BonusPoe_Objetivo = 4,
  BonusNeumaticos_Realizacion = 5,
  BonusNeumaticos_Objetivo = 6,
  AceitePnc = 7,
  AceiteLitros = 8,
  CnAxs = 9,
  Matriculas = 10,
  CNPinturaLimpiezaTaller = 11,
  CNCarroceria = 12,
  CNMecanica = 13,
  CNMantenimiento = 14,
  CNDesgaste = 15,
  CNMotrio = 16,
  CNValue = 17,
  CNNeumaticos = 18,
  CNComprasTotal = 19,
  VentasR1Mes_Realizacion = 20,
  VentasR1Mes_Objetivo = 21,
  VentasRASMes_Realizacion = 22,
  VentasRASMes_Objetivo = 23,
  VentasTMMes_Realizacion = 24,
  VentasTMMes_Objetivo = 25,
  VentasR3Mes_Realizacion = 26,
  VentasR3Mes_Objetivo = 27,
  PnfRAS = 28,
  PnfR3 = 29,
  PnfTM = 30,
  VentasCarrR3 = 31,
  PnfCarrR3 = 32,
  VentasEUKR3 = 33,
  PnfEUKR3 = 34,
  VentasCarrTM = 35,
  PnfCarrTM = 36,
  VentasEUKTM = 37,
  PnfEUKTM = 38,
  VentasEUR3 = 39,
  VentasKR3 = 40,
  CNComprasTotalPvp = 41,
  Parque1 = 42,
  Parque2 = 43,
  Parque3 = 44,
  Parque4 = 45,
  Parque5 = 46,
  Parque6 = 47,
  Parque7 = 48,
  Parque8 = 49,
  Parque9 = 50,
  Parque10 = 51,
  Parque11 = 52,
  Parque12 = 53,
  Parque13 = 54,
  Parque14 = 55,
  Parque15 = 56,
  VisitasTaller = 57,
  FacturacionHoraTaller = 58,
  VentasCalidadMes_Realizacion = 59,
  PnfCalidad = 60,
  VentasRestoR1Mes_Realizacion = 61,
  PnfRestoR1 = 62,
  RankingCalidad = 63,
  TFA = 64,
  ScoreRenault = 65,
  ScoreDacia = 66,
  NPS_PV_Mes = 67,
  NPS_PV_Q = 68,
  NPS_Cliente_Preferente_Mes = 69,
  NPS_Cliente_Preferente_Q = 70,
  NPS_Calidad_Trabajo_Mes = 71,
  NPS_Calidad_Trabajo_Q = 72,
  TR_Mes = 73,
  TR_Q = 74,
  VOC_Index_Mes = 75,
  VOC_Index_Q = 76,
  VOC_Index_Y = 77,
  Leadtime_Q = 78,
  Leadtime_Y = 79,
  CM_Index_Q = 80,
  CM_Index_Y = 81,
  DQA = 82,
  DQA_PV = 83,
  KPI_Estrategico_Q = 84,
  KPI_Estrategico_Q_Name = 85,
  ContratosExtension = 88,
  ContratosMantenimiento = 89,
  ContratosVn = 90,
  NPS_PV_Y = 92,
  NPS_Cliente_Preferente_Y = 93,
  NPS_Calidad_Trabajo_Y = 94,
  TR_Y = 95,
  RC_Matricula_Financiado = 96,
  RC_Matricula_SAlone = 97,
  RC_RC5_Financiado = 98,
  RC_RC5_SAlone = 99,
  RC_Matricula_Total = 100,
  RC_RC5_Total = 101,
  FIC_Total = 102,
  FIC_Justificadas = 103,
  FIC_Injustificadas = 104,
  FIC_Tratamiento_Total = 105,
  FIC_Tratamiento_Red = 106,
  FIC_Tratamiento_Otros = 107,
  THG = 108,
  THC = 109,
  BonusTHG = 110,
  BonusTHG_en_curso = 111,
  Budget_RCL = 112,
  Budget_RCL_Consumido = 113,
  Budget_VS = 114,
  Budget_VS_Consumido = 115,
  BonusVentasR1 = 116,
  BonusVentasRAS = 117,
  BonusVentasR3 = 118,
  BonusVentasTM = 119,
  Resultado_APR = 120,
  Resultado_APR_Porc = 121,
  Aport_Const_APR = 122,
  Aport_Const_APR_Porc = 123,
  Dcto_Red = 124,
  Dcto_Red_Porc = 125,
  Dcto_Ext = 126,
  Dcto_Ext_Porc = 127,
  Dcto_Taller = 128,
  Dcto_Taller_Porc = 129,
  Resultado_Taller = 130,
  Resultado_Taller_Porc = 131,
  Resultado_Taller_Sin_PR = 132,
  Resultado_Taller_Sin_PR_Porc = 133,
  Aport_Const_Taller = 134,
  Aport_Const_Taller_Porc = 135,
  Resultado_Pintura = 136,
  Resultado_Pintura_Porc = 137,
  Productividad_103 = 138,
  Rendimiento_85 = 139,
  Eficacia_88 = 140,
  Resultado_PV = 141,
  Contribucion_PV = 142,
  Tasa_Absorcion = 143,
  Gastos_COM_ESTR_FINAN = 144,
  Gastos_COM_ESTR_FINAN_Porc = 145,
  Gastos_Fijos = 146,
  Gastos_Fijos_Porc = 147,
  Resultado_Final = 148,
  Resultado_Final_Porc = 149,
  Resultado_Actividades = 150,
  Resultado_Actividades_Porc = 151,
  Fecha_Ultima_Auditoria = 152,
  Importe_Ultima_Auditoria = 153,
  CNAceite = 154,
  Stock = 155,
  StockMuerto = 156,
  Lineas = 157,
  Boletines = 158,
  VHP_SUS = 159,
  Incidencias = 160,
  Cobertura = 161,
  TasaSDir = 162,
  TasaSDirEUP = 163,
  RgShareTotal = 164,
  RgShareR1 = 165,
  RgShareR2 = 166,
  RgShareR3 = 167,
  CnVentasR1PinturaLimpieza = 168,
  CnVentasR1Carroceria = 169,
  CnVentasR1Mecanica = 170,
  CnVentasR1Mantenimiento = 171,
  CnVentasR1Desgaste = 172,
  CnVentasR1Motrio = 173,
  CnVentasR1Value = 174,
  CnVentasR1Neumaticos = 175,
  CnVentasR1Aceite = 176,
  CnVentasR1Total = 177,
  CnVentasR2PinturaLimpieza = 178,
  CnVentasR2Carroceria = 179,
  CnVentasR2Mecanica = 180,
  CnVentasR2Mantenimiento = 181,
  CnVentasR2Desgaste = 182,
  CnVentasR2Motrio = 183,
  CnVentasR2Value = 184,
  CnVentasR2Neumaticos = 185,
  CnVentasR2Aceite = 186,
  CnVentasR2Total = 187,
  CnVentasR3PinturaLimpieza = 188,
  CnVentasR3Carroceria = 189,
  CnVentasR3Mecanica = 190,
  CnVentasR3Mantenimiento = 191,
  CnVentasR3Desgaste = 192,
  CnVentasR3Motrio = 193,
  CnVentasR3Value = 194,
  CnVentasR3Neumaticos = 195,
  CnVentasR3Aceite = 196,
  CnVentasR3Total = 197,
  CnVentasTMPinturaLimpieza = 198,
  CnVentasTMCarroceria = 199,
  CnVentasTMMecanica = 200,
  CnVentasTMMantenimiento = 201,
  CnVentasTMDesgaste = 202,
  CnVentasTMMotrio = 203,
  CnVentasTMValue = 204,
  CnVentasTMNeumaticos = 205,
  CnVentasTMAceite = 206,
  CnVentasTMTotal = 207,
  CnVentasTotal = 208,
  MyServiceContratosVN = 209,
  MyServiceMatriculasVN = 210,
  MyServiceContratosPvEsencial = 211,
  MyServiceEntradasContMant = 212,
  ProactividadRCL = 213,
  ProactividadPSQPSC = 214,
  ProactividadSRCDealer = 215,
  ProactividadSumaSRC = 216,
  ReclamacionesTotales = 217,
  ReclamacionesPiezas = 218,
  ReclamacionesIncTec = 219,
  ReclamacionesLead = 220,
  ReclamacionesSinHTL = 221,
  MyServiceContratosPvIntegral = 222,
  MyServiceContratosPvTotal = 223,
}

export enum KpiInfo {
  BonusPO = 1,
  BonusPOE = 2,
  BonusPO_POE = 3,
  BonusNeumaticos = 4,
  AceitePNC = 5,
  AceiteLitros = 6,
  CnAxs = 7,
  Matriculas = 8,
  RatioAxs = 9,
  CNComprasTotal = 10,
  CNPinturaLimpiezaTaller = 11,
  CNCarroceria = 12,
  CNMecanica = 13,
  CNMantenimiento = 14,
  CNDesgaste = 15,
  CNMotrio = 16,
  CNValue = 17,
  CNNeumaticos = 18,
  CNAceite = 19,
  BonusVentasR1 = 20,
  BonusVentasRAS = 21,
  BonusVentasTM = 22,
  BonusVentasR3 = 23,
  DescuentoRAS = 24,
  DescuentoR3 = 25,
  DescuentoTM = 26,
  DescuentoCarr_R3 = 27,
  DescuentoEUK_R3 = 28,
  DescuentoCarr_TM = 29,
  DescuentoEUK_TM = 30,
  RatioComprasVentas_Porc = 31,
  RatioComprasVentas_Eur = 32,
  RatioVentasMD_R3 = 33,
  RatioVentasMotrio_R3 = 34,
  CMPCompras9 = 35,
  CMPComprasTotal = 36,
  CMPVentasRAS = 37,
  CMPVentasR3_TM = 38,
  CMPVentasCarr_R3_TM = 39,
  CMPVentasEUK_R3_TM = 40,
  Entradas = 41,
  HorasFacturadas = 42,
  Facturacion = 43,
  TicketMedio = 44,
  Parque = 45,
  TFA = 46,
  ScoreRenault = 47,
  ScoreDacia = 48,
  NPSVoC = 49,
  NPS_Cliente_Preferente = 50,
  NPS_Calidad_Trabajo = 51,
  TasaRetorno = 52,
  VOC_Index = 53,
  Leadtime = 54,
  CM_Index = 55,
  KPI_Estrategico = 56,
  DQA = 57,
  DQA_PV = 58,
  BonusCalidad = 59,
  FIC = 60,
  TiempoFIC = 61,
  THG = 62,
  THC = 63,
  THG_THC = 64,
  BonusTHG = 65,
  PresupuestoRCL = 66,
  PresupuestoVS = 67,
  UltimaAuditoria = 68,
  PenetracionContratos = 69,
  ReanultCare = 70,
  ReimpactoNacional = 71,
  CampannaLocal = 72,
  Resultado_Final = 73,
  Resultado_Actividades = 74,
  Resultado_PV = 75,
  Tasa_Absorcion = 76,
  Resultado_APR = 77,
  Aport_Const_APR = 78,
  Dcto_Red = 79,
  Dcto_Ext = 80,
  Dcto_Taller = 81,
  Resultado_Taller = 82,
  Resultado_Taller_Sin_PR = 83,
  Aport_Const_Taller = 84,
  Resultado_Pintura = 85,
  Gastos_COM_ESTR_FINAN = 86,
  Gastos_Fijos = 87,
  Productividad_103 = 88,
  Rendimiento_85 = 89,
  Eficacia_88 = 90,
  Stock = 91,
  Porc_Stock_Muerto = 92,
  StockMuerto = 93,
  Cobertura = 94,
  TasaSDir = 95,
  TasaSDirEUP = 96,
  TasaDisponibilidad = 97,
  VHP_SUS = 98,
  TasaCalidad = 99,
  Reclamaciones = 100,
  TasaBoletines = 101,
  Boletines = 102,
  RankingCalidad = 103,
  EntradasVsParque = 104,
  CNVentasTotal = 105,
  CNVentasPinturaLimpiezaTaller = 106,
  CNVentasCarroceria = 107,
  CNVentasMecanica = 108,
  CNVentasMantenimiento = 109,
  CNVentasDesgaste = 110,
  CNVentasMotrio = 111,
  CNVentasValue = 112,
  CNVentasNeumaticos = 113,
  CNVentasAceite = 114,
  Proactividad = 115,
  ReclamacionesTotales = 116,
  ReclamacionesVisitas = 117,
  ReclamacionesLead = 118,
  ReclamacionesSinHTL = 119,
  MyServicePV = 120,
  PesoMantenimiento = 121,
}

export enum KpiType {
  KpiData = 1,
  KpiActividadTallerVisits = 2,
  KpiActividadTallerBillingHour = 3,
  KpiActividadTallerTfa = 4,
  KpiExperienciaClienteBonusCalidad = 5
}

export enum MathOperation {
  Division = 1,
  Resta = 2
}

export enum KpiWorkshopType {
  Mecanica = 1,
  Carroceria = 2
}

export enum KpiInvoiceType {
  Complement = 1,
  FixedPrice = 2,
  Labour = 3,
  Parts = 4
}

export enum KpiComparativeType {
  SameYear = 1,
  DifferentYear = 2,
  OldType = 3,
  BonusThg = 4
}


export enum PuntoapuntoRoles
{
    R2 = 4,
    R3 = 5,
    Motrio = 6
}
export enum KpiFileLoadType {
  Anual = 1,
  Mensual = 2,
  Cuatrimestral = 3
}

export enum LeadSource {
  Internet = 1,
  SRC = 2,
  R2 = 3,
  PuntoDeRed = 4
}

export enum AmazonCardType {
  AnimacionRed = 1,
  Dsp = 2
}